import { Component } from '@angular/core';

@Component({
  selector: 'app-it-services',
  imports: [],
  templateUrl: './it-services.html',
  styleUrl: './it-services.scss'
})
export class ITServices {

}
